<script>
    import { get } from "svelte/store";
    import Button from "./Button.svelte";
    import { SAVE_PREFIX } from "./globals.js";
    import { MULTIPLAYER_SERVER_CHOOSER, PLAY } from "./routes";
    import { connected, isInRoom } from "./stores";
    export let setRoute;
    let saveFiles = [];
    let saveFilesQuicksaves = [];
    function getSaveFiles() {
        const allSaveFiles = Object.keys(localStorage)
            // Get all localStorage that are save files
            .filter((x) => x.includes(SAVE_PREFIX))
            // Get the name that doesn't include the save prefix
            .map((x) => x.split(SAVE_PREFIX).join(""))
            .map((saveFileName) => {
                const [dateString, saveName] = saveFileName.split("-");
                const parsedDate = parseInt(dateString);
                return {
                    saveFileName,
                    date: isNaN(parsedDate) ? 0 : parsedDate,
                    isQuicksave: saveFileName.includes("quicksave"),
                    displayName: isNaN(parsedDate)
                        ? saveFileName
                        : saveName !== ""
                          ? saveName
                          : new Date(parsedDate).toString(),
                };
            })
            // Have most recent at the top
            .sort((a, b) => b.date - a.date);
        saveFiles = allSaveFiles.filter((s) => !s.isQuicksave);
        saveFilesQuicksaves = allSaveFiles.filter((s) => s.isQuicksave);
    }
    getSaveFiles();
</script>

<div class="flex">
    <aside>
        <div class="flex flex-direction-column gap-15 pad-20">
            <div class="flex align-items-center gap-20">
                <Button
                    on:click={() => {
                        if (
                            get(connected) &&
                            get(isInRoom) &&
                            !globalThis.player.lobbyReady &&
                            !globalThis.pie.soloMode
                        ) {
                            setRoute(MULTIPLAYER_SERVER_CHOOSER);
                        } else {
                            window.goBack();
                        }
                    }}
                    type="button"
                    text="🠔 Back"
                    class="sm"
                />
                <h1 class="aside-title">
                    {globalThis.i18n("Previous Games")}
                </h1>
            </div>
        </div>
    </aside>

    <main class="flex">
        <div class="pad-20 flex flex-direction-column gap-15">
            <h2>Saved Games</h2>
            {#each saveFiles as saveFile}
                <div class="flex gap-15">
                    <Button
                        on:click={() => window.load(saveFile.saveFileName)}
                        type="button"
                        text={saveFile.displayName}
                        style="min-width:300px; overflow:hidden;"
                    />
                    <Button
                        on:click={() => {
                            window
                                .deleteSave(saveFile.saveFileName)
                                .then(() => {
                                    getSaveFiles();
                                });
                        }}
                        type="button"
                        text={"X"}
                        style="width:65px"
                    />
                </div>
            {/each}
        </div>
        <div class="pad-20 flex flex-direction-column gap-15">
            <h2>Quicksaves</h2>
            {#each saveFilesQuicksaves as saveFile}
                <div class="flex gap-15">
                    <Button
                        on:click={() => window.load(saveFile.saveFileName)}
                        type="button"
                        text={saveFile.displayName}
                        style="min-width:300px; overflow:hidden;"
                    />
                    <Button
                        on:click={() => {
                            window
                                .deleteSave(saveFile.saveFileName)
                                .then(() => {
                                    getSaveFiles();
                                });
                        }}
                        type="button"
                        text={"X"}
                        style="width:65px"
                    />
                </div>
            {/each}
        </div>
    </main>
</div>

<style>
    main {
        max-height: 95vh;
        overflow: auto;
    }
    aside {
        border-right: 2px solid #efefef;
        width: 300px;
        /* Ensure that the options aside will become scrollable if the screen is too small */
        overflow-y: auto;
        /* Ensure it doesn't overlap with the border around the edges of the window */
        max-height: 90vh;
    }
</style>
